import Template from './Template';

export type SortableField = 'template_name' | 'reference_label';
export type SortDirection = 'asc' | 'desc';

export interface SortingPreferences {
  field: SortableField | null;
  direction: SortDirection;
}

export const DEFAULT_SORT_DIRECTION: SortDirection = 'asc';

const getFieldValue = (template: Template, field: SortableField): string => {
  if (field === 'template_name') {
    return template.name;
  } else if (field === 'reference_label') {
    return template.reference_label;
  }

  return '';
};

export const sortBy = (templates: Template[], preferences: SortingPreferences): Template[] => {
  const { field, direction } = preferences;

  if (field === null) {
    return templates;
  }

  const stabilizedRecords = templates.map((el, index) => [el, index] as [Template, number]);

  stabilizedRecords.sort((a, b) => {
    const [aRecord, aIndex] = a;
    const [bRecord, bIndex] = b;

    const aValue = getFieldValue(aRecord, field).toUpperCase();
    const bValue = getFieldValue(bRecord, field).toUpperCase();

    const comparisson = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    const diff = direction === 'asc' ? comparisson : 0 - comparisson;

    const x = diff !== 0 ? diff : direction === 'asc' ? aIndex - bIndex : bIndex - aIndex;

    // console.log([comparisson, x, aValue, bValue]);
    return x;
  });

  return stabilizedRecords.map(([record]) => record);
};
